import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/theme/loading.webp'


const _hoisted_1 = {
  key: 1,
  class: "loadingImage",
  src: _imports_0,
  alt: "",
  width: "25%"
}

import { useThemeStore } from '@/stores/theme'
import {  ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'loadingScreen',
  props: {
    content: {
        type: String,
        default: () => ''
    },
    isLoading: {
        type: Boolean,
        default: () => false
    },
    isShowSuccess: {
        type: Boolean,
        default: () => false
    }
},
  setup(__props, { expose: __expose }) {

const themeStore = useThemeStore()
const show = ref(false)

const props = __props
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    style: {
        minWidth: '100%',
        minHeight: '100%',
        background: '#0000002e',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        padding: '10px 15px',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        zIndex: '10002'
    }
  }, {
    default: _withCtx(() => [
      (_unref(themeStore).themeIndex === 1)
        ? (_openBlock(), _createBlock(_component_van_loading, {
            key: 0,
            type: "spinner",
            size: "60"
          }))
        : _createCommentVNode("", true),
      (_unref(themeStore).themeIndex === 2)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : _createCommentVNode("", true),
      (_unref(themeStore).themeIndex === 3)
        ? (_openBlock(), _createBlock(_component_van_loading, {
            key: 2,
            type: "spinner",
            color: "#1989fa",
            size: "30"
          }))
        : _createCommentVNode("", true),
      (_unref(themeStore).themeIndex === 4)
        ? (_openBlock(), _createBlock(_component_van_loading, {
            key: 3,
            type: "spinner",
            color: "#0db0ae",
            size: "30"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})